import {cloneDeep, map} from 'lodash';

import Category from './filter/Category';
import React from 'react';
import PropTypes from 'prop-types';

const CategoriesContainer = React.memo(function CategoriesContainer ({
  notFocusable,
  elements,
  getCategories,
  disabled,
  isUnique,
  isRadio,
  clickOff
}) {
  const handleClick = (index) => {
    if (getCategories) {
      let copy = cloneDeep(elements);
      if (isUnique) {
        copy = map(copy, (elem) => {
          elem.clicked = false;
          return elem;
        });
      }
      copy[index].clicked = !elements[index].clicked;
      getCategories(copy);
    }
  };

  return (
    <div
      style={{
        display: 'contents', justifyContent: 'center',
      }}
    >
      {elements?.map((category, index) => {
        return (
          <Category
            ariaDescribedBy={category.ariaDescribedBy}
            ariaLabel={category.ariaLabel}
            basecolor={category.disable ? 'var(--light-grey-color)' : category.basecolor}
            clickOff={clickOff !== undefined ? clickOff : category.clickOff}
            clicked={category.clicked}
            disablePointer={category.disable ? {
              pointerEvents: 'none', cursor: 'default'
            } : {}}
            disabled={disabled || category.disable}
            handleClick={() => {
              if ((isRadio && category.clicked) || disabled) return;
              handleClick(index);
            }}
            key={index}
            label={category.label}
            lang={category.lang}
            notFocusable={notFocusable}
            onKeyDown={() => {
              if (!disabled && !category.clicked && !isRadio) handleClick(index);
            }}
            underline={category.clicked}
            variant={category.variant}
          />);
      })}
    </div>
  );
});

CategoriesContainer.propTypes = {
  clickOff: PropTypes.bool,
  disabled: PropTypes.bool,
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
      ]),
      variant: PropTypes.string,
      clicked: PropTypes.bool,
      lang: PropTypes.string,
      disable: PropTypes.bool,
      ariaLabel: PropTypes.string,
      ariaDescribedBy: PropTypes.string,
      clickOff: PropTypes.bool,
      basecolor: PropTypes.string,
    })
  ),
  getCategories: PropTypes.func,
  isRadio: PropTypes.bool,
  isUnique: PropTypes.bool,
  notFocusable: PropTypes.bool,
};

export default CategoriesContainer;
